@let isFtl = isDedicated() ? 'ftl' : 'ltl';
<onyx-icon
  class="f-muted"
  [name]="`${isFtl}-outlined`"
  [size]="20"
  [onyxTooltip]="isFtl | uppercase"
  [onyxTooltipDelay]="TOOLTIP_DELAY"
></onyx-icon>
